module.exports = __webpack_public_path__ + "img/boomerang.14e5b1a5.svg";